import BASE_URL from "../config/apiConfig";

export const PropertyService = {
  // Function to get the auth token from session storage
  getAuthToken() {
    return sessionStorage.getItem("jwt");
  },

  async fetchProperty(propertyId: any) {
    const token = this.getAuthToken();
    try {
      const response = await fetch(`${BASE_URL}Property/${propertyId}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          ...(token && { Authorization: `Bearer ${token}` }),
        },
      });

      if (!response.ok) {
        throw new Error("Failed to fetch properties");
      }

      return await response.json();
    } catch (error) {
      console.error("Error fetching properties:", error);
      throw error;
    }
  },

  // Fetch property data (GET)
  async fetchProperties() {
    const token = this.getAuthToken();
    try {
      const response = await fetch(`${BASE_URL}Property/GetProperties`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          ...(token && { Authorization: `Bearer ${token}` }),
        },
      });

      if (!response.ok) {
        throw new Error("Failed to fetch properties");
      }

      return await response.json();
    } catch (error) {
      console.error("Error fetching properties:", error);
      throw error;
    }
  },

  // Add or update property data (POST)
  async postProperty(propertyData: any) {
    const token = this.getAuthToken();
    try {
      const response = await fetch(`${BASE_URL}Property/AddProperty`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          ...(token && { Authorization: `Bearer ${token}` }),
        },
        body: JSON.stringify(propertyData),
      });

      if (!response.ok) {
        throw new Error("Failed to create/update property");
      }

      return await response.json();
    } catch (error) {
      console.error("Error posting property:", error);
      throw error;
    }
  },

  async updateProperty(propertyData: any) {
    const token = this.getAuthToken();
    try {
      const response = await fetch(
        `${BASE_URL}Property/${propertyData.propertyId}`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            ...(token && { Authorization: `Bearer ${token}` }),
          },
          body: JSON.stringify(propertyData),
        }
      );

      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(`Failed to update property: ${errorText}`);
      }

      return await response.json();
    } catch (error) {
      console.error("Error updating property:", error);
      throw error;
    }
  },
  async deleteProperty(propertyId: number) {
    const token = this.getAuthToken();
    try {
      const response = await fetch(`${BASE_URL}Property/${propertyId}`, {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          ...(token && { Authorization: `Bearer ${token}` }),
        },
      });

      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(`Failed to delete property: ${errorText}`);
      }

      return await response.json();
    } catch (error) {
      console.error("Error deleting property:", error);
      throw error;
    }
  },
};
